"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.writingStyles.disabled': 'La funzione stili di scrittura non è disponibile nel tuo piano attuale.',
};
